<template>
  <div id="addPersonnel">
    <Loading v-if="show"></Loading>
    <div class="registration-container" v-else>
      <div class="registration-container">
        <div id="num_popup" v-show="flags.isTiketModalShow">
          <ChooseTicketModal
            :datas="ticketModalsDatas"
            @submit="handleGetTicketDatas"
          />
        </div>

        <div class="registration_main" v-if="signUpData">
          <div class="registration-banner">
            <img :src="signUpData.signUp_Set.mobile_image || bannerSrc" alt />
          </div>
          <div class="registration-content">
            <h2 class="registrationContent-title">
              <span>{{ this.meetingInfo.MeetingTitle }}</span>
            </h2>

            <van-collapse v-model="activeNames">
              <van-collapse-item
                v-for="(items, indexs) in forms"
                :key="indexs"
                :name="indexs"
                id="sl-collapse-item"
              >
                <div slot="title" :class="{ disNone: forms.length == 1 }">
                  第{{ indexs + 1 }}位
                </div>
                <form action class="registrationContent-form">
                  <template v-for="(item, index) in items">
                    <!-- 输入框 -->
                    <div
                      class="formItem"
                      :key="index"
                      v-if="item.formtype === 1 && item.formfix === 0"
                    >
                      <div class="formItem-title">
                        {{ item.formtitle }}
                        <span v-show="item.isreq" class="mustfill">*</span>
                      </div>
                      <input
                        type="text"
                        name
                        :placeholder="item.formdes"
                        v-model="item.formval"
                        :formfix="item.formfix"
                        @blur="publicSignup.on_blur()"
                      />
                    </div>
                    <!-- 姓名 -->
                    <div
                      class="formItem"
                      :key="index"
                      v-if="item.formtype === 1 && item.formfix === 2"
                    >
                      <div class="formItem-title">
                        {{ item.formtitle }}
                        <span v-show="item.isreq" class="mustfill">*</span>
                      </div>
                      <input
                        type="text"
                        name
                        :placeholder="item.formdes"
                        v-model="item.formval"
                        :formfix="item.formfix"
                        @blur="publicSignup.on_blur()"
                      />
                    </div>
                    <!-- 手机号 -->
                    <div
                      class="formItem"
                      :key="index"
                      v-if="item.formtype === 1 && item.formfix === 1"
                    >
                      <div class="formItem-title">
                        {{ item.formtitle }}
                        <span v-show="item.isreq" class="mustfill">*</span>
                      </div>
                      <input
                        type="text"
                        name
                        :placeholder="item.formdes"
                        v-model="item.formval"
                        @change="regCheck(item, 'tel', $event)"
                        class="telVal"
                        @input="signIn"
                        @blur="publicSignup.on_blur()"
                      />
                    </div>
                    <!-- 邮箱 -->
                    <div
                      class="formItem"
                      :key="index"
                      v-if="item.formtype === 1 && item.formfix === 3"
                    >
                      <div class="formItem-title">
                        {{ item.formtitle }}
                        <span v-show="item.isreq" class="mustfill">*</span>
                      </div>
                      <input
                        type="text"
                        name
                        :placeholder="item.formdes"
                        v-model="item.formval"
                        class="telVal"
                        @change="regCheck(item, 'Email', $event)"
                        @blur="publicSignup.on_blur()"
                      />
                    </div>
                    <!-- 身份证 -->
                    <div
                      class="formItem"
                      :key="index"
                      v-if="item.formtype === 1 && item.formfix === 4"
                    >
                      <div class="formItem-title">
                        {{ item.formtitle }}
                        <span v-show="item.isreq" class="mustfill">*</span>
                      </div>
                      <input
                        type="text"
                        name
                        :placeholder="item.formdes"
                        v-model="item.formval"
                        class="telVal"
                        @blur="publicSignup.on_blur()"
                      />
                    </div>
                    <!-- 单选 -->
                    <div
                      class="formItem"
                      :key="index"
                      v-else-if="item.formtype === 2 && item.formfix === 0"
                    >
                      <div class="formItem-title">
                        {{ item.formtitle }}
                        <span v-show="item.isreq" class="mustfill">*</span>
                      </div>
                      <van-radio-group v-model="item.formval">
                        <van-radio
                          :name="itemChild.value"
                          icon-size="16"
                          v-for="(itemChild, i) in item.formjsonval"
                          :key="i"
                          >{{ itemChild.value }}</van-radio
                        >
                      </van-radio-group>
                    </div>
                    <!-- 性别 -->
                    <div
                      class="formItem"
                      :key="index"
                      v-else-if="item.formtype === 2 && item.formfix === 5"
                    >
                      <div class="formItem-title">
                        {{ item.formtitle }}
                        <span v-show="item.isreq" class="mustfill">*</span>
                      </div>
                      <van-radio-group v-model="item.formval">
                        <van-radio
                          :name="itemChild.value"
                          icon-size="16"
                          v-for="(itemChild, i) in item.formjsonval"
                          :key="i"
                          >{{ itemChild.value }}</van-radio
                        >
                      </van-radio-group>
                    </div>
                    <!-- 多选 -->
                    <div
                      class="formItem"
                      :key="index"
                      v-else-if="item.formtype === 3"
                    >
                      <div class="formItem-title">
                        {{ item.formtitle }}
                        <span v-show="item.isreq" class="mustfill">*</span>
                      </div>
                      <van-checkbox-group v-model="item.formval">
                        <van-checkbox
                          :name="itemChild.value"
                          shape="square"
                          icon-size="16"
                          v-for="(itemChild, i) in item.formjsonval"
                          :key="i"
                          >{{ itemChild.text }}</van-checkbox
                        >
                      </van-checkbox-group>
                    </div>
                    <!-- 下拉框 -->
                    <div
                      class="formItem"
                      :key="index"
                      v-else-if="item.formtype === 4"
                    >
                      <div class="formItem-title">
                        {{ item.formtitle }}
                        <span v-show="item.isreq" class="mustfill">*</span>
                      </div>
                      <van-icon
                        name="arrow-down"
                        color="#64748b"
                        class="downIcon"
                        size="1.39rem"
                      />
                      <select
                        v-model="item.formval"
                        @blur="publicSignup.on_blur()"
                      >
                        <option
                          v-for="(itemChild, i) in item.formjsonval"
                          :key="i"
                          :value="itemChild.value"
                          >{{ itemChild.text }}</option
                        >
                      </select>
                    </div>
                    <!-- 多行文本 -->
                    <div
                      class="formItem"
                      :key="index"
                      v-if="item.formtype === 5"
                    >
                      <div class="formItem-title">
                        {{ item.formtitle }}
                        <span v-show="item.isreq" class="mustfill">*</span>
                      </div>
                      <textarea
                        class="textarea"
                        v-model="item.formval"
                      ></textarea>
                    </div>
                    <!-- 日期 -->
                    <div
                      class="formItem"
                      :key="index"
                      v-else-if="item.formtype === 9"
                    >
                      <div class="formItem-title">
                        {{ item.formtitle }}
                        <span v-show="item.isreq" class="mustfill">*</span>
                      </div>
                      <van-cell
                        is-link
                        arrow-direction="down"
                        @click="isShowPopup(item)"
                        >{{ item.formval }}</van-cell
                      >
                      <van-popup
                        v-model="item.isShow"
                        round
                        position="bottom"
                        :style="{ height: '50%' }"
                        class="timePupop"
                      >
                        <van-datetime-picker
                          v-model="item.currentDate"
                          type="date"
                          @confirm="(date) => getTime(date, item)"
                          @cancel="isShowPopup(item)"
                          :min-date="minDate"
                        />
                      </van-popup>
                    </div>

                    <!-- 搜索下拉框 -->
                    <div
                      class="formItem"
                      :key="index"
                      v-if="item.formtype === 8"
                    >
                      <div class="formItem-title">
                        {{ item.formtitle }}
                        <span v-show="item.isreq" class="mustfill">*</span>
                      </div>
                      <van-search
                        :placeholder="item.formdes"
                        v-model="item.formval"
                        @focus="showSearchOption = true"
                        @blur="blurs"
                        @input="searchOptions(item)"
                      />
                      <div class="searchOption" v-show="showSearchOption">
                        <ul
                          class="searchOption-list"
                          v-if="item.searchVal != false"
                        >
                          <li
                            class="searchOption-item"
                            v-for="(itemChild, i) in item.searchVal"
                            :key="i"
                            @click.prevent="getSearchVal(itemChild.value, item)"
                          >
                            {{ itemChild.value }}
                          </li>
                        </ul>
                        <ul class="searchOption-list" v-else>
                          <li
                            class="searchOption-item"
                            v-for="(itemChild, i) in item.formjsonval"
                            :key="i"
                            @click.prevent="getSearchVal(itemChild.value, item)"
                          >
                            {{ itemChild.value }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <!-- 省市区 -->
                    <div
                      class="formItem"
                      :key="index"
                      v-else-if="item.formtype === 6"
                    >
                      <div class="formItem-title">
                        {{ item.formtitle }}
                        <span v-show="item.isreq" class="mustfill">*</span>
                      </div>
                      <van-cell
                        is-link
                        arrow-direction="down"
                        @click="isShowPopup(item)"
                        >{{ item.formval }}</van-cell
                      >

                      <van-popup
                        v-model="item.isShow"
                        round
                        position="bottom"
                        :style="{ height: '50%' }"
                        class="addressPupop"
                      >
                        <van-area
                          :value="item.formval"
                          :area-list="areaList"
                          @confirm="(adress) => getAddress(adress, item)"
                          @cancel="isShowPopup(item)"
                          :columns-num="3"
                        />
                      </van-popup>
                    </div>

                    <!-- 分割线 -->
                    <div
                      class="divider"
                      :key="index"
                      v-else-if="item.formtype === 7"
                    >
                      <div class="formItem-title">
                        {{ item.formtitle }}
                        <span v-show="item.isreq" class="mustfill">*</span>
                      </div>
                      <div class="dividerLine"></div>
                    </div>
                  </template>
                </form>
              </van-collapse-item>
            </van-collapse>
            <div class="registration-nextStep">
              <div class="reselect">
                <div
                  class="reselect-content"
                  @click="showPupop()"
                  v-if="flags.isTicketTypeList"
                >
                  更改票种或人数
                  <van-icon name="records" />
                </div>
              </div>
              <div class="nextStep">
                <div class="nextStep_container" v-if="flags.isTicketTypeList">
                  合计：
                  <span>
                    ¥
                    <span class="total">{{ this.totalMoney }}</span>
                  </span>
                </div>
                <div
                  class="submitBtn nextBtn"
                  @click="submit"
                  v-if="!showSubmitBtn"
                >
                  <span>提交</span>
                </div>
                <div class="submitBtn nextBtn" v-else>
                  <van-loading size="20px" type="spinner" color="#fff"
                    >提交中...</van-loading
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '@components/Loading.vue'
import Area from '../../lib/area.js'
import publicSignup from '../../lib/signUp.js'
import wxShare from '../../lib/wxShare.js'
import ChooseTicketModal from './components/chooseTicketModal'

export default {
  neme: 'addPersonnel',
  components: {
    Loading,
    ChooseTicketModal,
  },
  data() {
    return {
      ticketModalsDatas: { ssl_count: '1', isMore: true }, //弹框数据
      flags: {
        isTiketModalShow: false, //是否显示选择票种的弹框
        isTicketTypeList: false, //是否显示合计
      },

      count: '1',
      bannerSrc: '',
      Area,
      forms: [], //多表单总数据
      activeNames: [0], // 手风琴默认展开第几个
      show: true,
      showSurplus: false, //余票
      title: '报名',
      selectTicket: '', //选中的票种
      selectPrice: '', //选中票种的金额
      numData: '1', //人数
      totalMoney: '', //总计金额
      showSearchOption: false,
      showfromTitle: true,
      signUpData: {
        signUp_Set: {},
      }, //接收的总数据
      ticketTypeDatas: {}, //票种id
      textareaVal: '', // 多行文本
      areaList: {}, //省市区
      addressData: [],
      searchVal: '', //搜索框的值
      currentDate: new Date(),
      params: { m: '' }, // code唯一标识
      showSubmitBtn: false, //提交中按钮
      settypeid: '',
      formdata: [], //表单数据
      minDate: new Date(), // 可选的最小日期
      publicSignup: {}, //通用js
      meetingInfo: {}, //会议基本信息
      is_check: false,
      is_multiuser: 0,
      sendFlag: true,
      regTel: true,
    }
  },
  watch: {
    count: {
      handler() {
        if (this.count == 1) {
          this.activeNames = [0]
        }
      },
    },
  },
  created() {
    const { m } = this.$route.query
    this.params.m = m
    this.areaList = Area
    let opt = { m }
    this.init(opt)
    this.publicSignup = new publicSignup()
  },
  async mounted() {
    window.addEventListener('resize', function() {
      if (document.activeElement.tagName === 'INPUT') {
        document.activeElement.scrollIntoView({ behavior: 'smooth' })
      }
    })
    let opt = {
      m: this.params.m,
      ch: this.$route.query.ch,
    }
    this.meetingInfo = await this.publicSignup.init(opt, this)

    //获取bnner图路径
    this.bannerSrc = this.meetingInfo.MobileBannerImage
  },

  computed: {
    meetId() {
      return this.$route.query.m
    },
  },
  methods: {
    async init() {
      this.fetchInitSignConfig()
    },
    /**
     * @description: 初始化报名配置接口
     */
    async fetchInitSignConfig() {
      const _params = {
        m: this.meetId,
      }
      try {
        const ress = await this.$http.InitAddSignConfig(_params)
        this.show = false
        console.log('总数据：', ress)
        if (ress.Code === 1000) {
          this.ticketModalsDatas = ress['signUp_Set']
          this.ticketModalsDatas.isMore = true
          this.flags.isTicketTypeList = ress['signUp_Set'].SignUpSetType.length
          //当票种数据为空并且未开启多人报名时，弹框不显示
          let _ticket = this.ticketModalsDatas
          if (!_ticket.SignUpSetType.length) {
            this.flags.isTiketModalShow = false
          } else {
            this.flags.isTiketModalShow = true
          }
          // -------------
          let res = this.deepCopy(ress)

          this.signUpData = this.deepCopy(ress)
          this.formdata = this.deepCopy(this.signUpData.form_Sets)
          if (res.signUp_Set.SignUpSetType) {
            this.ticketTypeDatas = res.signUp_Set.SignUpSetType
          }
          if (!res.signUp_Set.SignUpSetType && !this.is_multiuser) {
            this.isTiketModalShow = false
          } else {
            this.isTiketModalShow = true
          }

          this.setFormData()
         
        }
      } catch (error) {
        console.log(error)
      }
    },

    // ============
    async initShare(title, desc, link, imgUrl) {
      try {
        const headRes = await this.$http.csData({
          url: encodeURIComponent(
            window.location.href.replace(location.hash, '')
          ),
        })
        const _Wx = new wxShare({
          opt: headRes,
        })
        _Wx.ready().then((wx) => {
          _Wx.share(title, desc, link, imgUrl)
          console.log(wx)
        })
      } catch (err) {
        console.log(err)
      }
    },
    // 深拷贝
    isObj(obj) {
      return (
        (typeof obj === 'object' || typeof obj === 'function') && obj !== null
      )
    },
    deepCopy(obj, hash = new WeakMap()) {
      if (hash.has(obj)) return hash.get(obj)
      let cloneObj = Array.isArray(obj) ? [] : {}
      hash.set(obj, cloneObj)
      for (let key in obj) {
        cloneObj[key] = this.isObj(obj[key])
          ? this.deepCopy(obj[key], hash)
          : obj[key]
      }
      return cloneObj
    },

    getCheckedTicketIndex() {
      let selectPriceEl = document.querySelector('.ticketType_select .price')
      if (selectPriceEl) {
        this.selectPrice = selectPriceEl.innerHTML
        this.selectTicket = selectPriceEl.getAttribute('checkedTicket')
      }
    },
    // ---------------

    //二级数据
    subData(forms) {
      for (let j = 0; j < forms.length; j++) {
        forms[j].map((k, i) => {
          let _formtype = k.formtype
          if (
            _formtype === 2 ||
            _formtype === 4 ||
            _formtype === 8 ||
            _formtype === 3
          ) {
            let _formjsonval
            if (typeof k.formjsonval == 'string') {
              _formjsonval = JSON.parse(k.formjsonval)
            } else {
              _formjsonval = k.formjsonval
            }
            if (_formtype === 3) {
              if (!this.forms[j][i].formval) {
                this.forms[j][i].formval = []
              }
            }
            this.forms[j][i].formjsonval = _formjsonval
            if (_formtype === 2) {
              this.forms[j][i].formval = this.forms[j][i].formjsonval[0].value
            }
          }
        })
      }
    },

    // 控制选择日期/地址弹出框的显示和隐藏
    isShowPopup(item) {
      item.isShow = !item.isShow
      setTimeout(() => {
        let set = document.querySelectorAll('button')
        for (let i = 0; i < set.length; i++) {
          set[i].setAttribute('type', 'button')
        }
      }, 0)
    },
    // 选择日期/选择地址 回调事件
    getTime(date, item) {
      let day = date.getDate()
      let month = date.getMonth() + 1
      let year = date.getFullYear()
      item.isShow = false
      item.formval = year + '-' + month + '-' + day
    },
    // 省市区

    getAddress(address, item) {
      let _address = []
      for (let i = 0; i < address.length; i++) {
        _address.push(address[i].name)
      }
      item.isShow = false
      item.formval = _address.join('-')
    },

    // 只能输入数字
    signIn() {
      for (let i = 0; i < this.forms.length; i++) {
        this.forms[i].map((k) => {
          if (k.formfix === 1) {
            if (k.formval) {
              k.formval = k.formval.replace(/[^\d]/g, '')
            }
          }
        })
      }
    },
    //搜索列表
    getSearchVal(val, item) {
      item.formval = val
      this.showSearchOption = false
    },
    blurs() {
      setTimeout(() => {
        this.showSearchOption = false
      }, 0)
    },
    searchOptions(val) {
      if (val.formval) {
        for (let i = 0; i < val.formjsonval.length; i++) {
          let sd = val.formjsonval[i].value.indexOf(val.formval)
          if (sd != -1) {
            val.searchVal.push(val.formjsonval[i])
          }
        }
      } else {
        val.searchVal = []
      }
    },
    //提交表单
    submit() {
      if (!this.regTel) {
        this.$notify({
          message: '请输入正确的手机号！',
          type: 'danger',
        })
        return
      }
      // 判断必填项是否为空
      for (let i = 0; i < this.forms.length; i++) {
        const children = this.forms[i]
        for (let j = 0; j < children.length; j++) {
          const item = children[j]
          if (item.isreq) {
            if (!item.formval) {
              this.sendFlag = false
              const msg =
                this.forms.length > 1
                  ? '第' + (i + 1) + '位：' + item.formtitle
                  : item.formtitle
              this.activeNames = [i]
              this.$notify({
                message: msg + '不能为空',
                type: 'danger',
              })

              return
            }
          }
        }
      }

      //获取表单数据
      let data = [],
        _datas = []
      let cloneForms = this.deepCopy(this.forms)

      for (let s = 0; s < this.forms.length; s++) {
        for (let a = 0; a < this.forms[s].length; a++) {
          if (this.forms[s][a].formtype === 6) {
            cloneForms[s].push(this.forms[s][a])
          }
        }
      }
      for (let j = 0; j < cloneForms.length; j++) {
        for (let i = 0; i < cloneForms[j].length; i++) {
          if (cloneForms[j][i].formtype === 7) {
            cloneForms[j].pop(cloneForms[j][i])
          } else {
            if (cloneForms[j][i].formval === '请选择') {
              cloneForms[j][i].formval = ''
            }
            if (cloneForms[j][i].formtype === 3) {
              cloneForms[j][i].formval = String(cloneForms[j][i].formval)
            }

            data.push({
              value: cloneForms[j][i].formval,
              text: cloneForms[j][i].formtitle,
              formfix: cloneForms[j][i].formfix,
              formid: cloneForms[j][i].formid,
            })
          }
        }

        // console.log(data, this.forms)
        _datas.push(data)
        data = []
      }

      console.log('提交的表单', _datas)

      let UserEntity = []
      for (let i = 0; i < _datas.length; i++) {
        UserEntity.push({ DataEntity: _datas[i] })
      }

      let settypeid = this.settypeid || 0

      let { m, ch, teamid } = this.$route.query
      let datas = {
        m,
        settypeid: settypeid,
        teamid: Number(teamid),
        chid: Number(ch),
        UserEntity,
      }
      console.log(datas)
      //发送表单数据
      if (this.sendFlag) {
        this.showSubmitBtn = true
        this.submitform(datas)
      }
    },
    async submitform(datas) {
      try {
        let res = await this.$http.AddPageSignMeetingUser(datas)
        console.log(res)
        let { m } = this.$route.query
        if (res.Code === 1000) {
          this.$router.push({
            path: '/signup/signupinfo',
            query: { m },
          })
        }
        this.showSubmitBtn = false
      } catch (err) {
        console.log(err)
      }
    },

    setFormData() {
      console.log()
      let _formdata = this.formdata.map((k) => {
        if (k.formval === null) {
          k.formval = ''
        }
        //给日期和省市增加控制显示隐藏属性
        if (k.formtype === 6) {
          k.formval = '请选择'
          k.isShow = false
        }
        if (k.formtype === 8) {
          k.searchVal = []
        }
        if (k.formtype === 9) {
          k.formval = '请选择'
          k.currentDate = new Date()
          k.isShow = false
        }
        return {
          ...k,
        }
      })

      this.forms.push(this.deepCopy(_formdata))
      this.subData(this.forms)

      for (let i = 0; i < this.forms.length; i++) {
        for (let j = 0; j < this.forms[i].length; j++) {
          if (
            this.forms[i][j].formtype === 1 &&
            this.forms[i][j].formfix === 1
          ) {
            this.forms[i][j].formval = ''
          }
        }
      }
    },
    regCheck(val, type, event) {
      this.regTel = this.publicSignup.regCheck(val.formval, type, event, this)
    },
    handleGetTicketDatas(val) {
      this.flags.isTiketModalShow = false
      this.totalMoney = val.totalMoney
      this.settypeid = val.settypeid
      console.log(val, '-----')
      if (this.count < val.count) {
        let _count = val.count - this.count
        for (let i = 0; i < _count; i++) {
          this.setFormData()
        }
      } else if (this.count > val.count) {
        let _count = this.count - val.count
        for (let i = 0; i < _count; i++) {
          this.forms.pop()
        }
      }
      this.count = val.count
    },
    showPupop() {
      this.ticketModalsDatas.ssl_count = this.count
      this.flags.isTiketModalShow = true
    },
  },
}
</script>
<style lang="scss">
.van-dialog {
  width: 60%;
  text-align: center;
  font-size: 32px;
  padding-top: 20px;
  .van-dialog__content {
    margin: 20px 0;
  }
  .van-button {
    font-size: 32px;
    line-height: 60px;
    height: 60px;
  }
}
input {
  -webkit-appearance: none;
  border: none;
  border-radius: none;
}

.van-field__clear {
  font-size: 1rem;
  right: 0.8rem !important;
}
#addPersonnel {
  .registration-container {
    .registration-content {
      #sl-collapse-item {
        margin-bottom: 30px;
        > div {
          padding: 0;
          &:first-child {
            padding: 0 10px;
          }
          > .van-cell__title {
            line-height: 80px;
            font-size: 32px;
            padding-left: 10px;
            color: #475569;
          }
          > .van-icon {
            line-height: 80px;
            font-size: 34px;
          }
        }
      }
      .registrationContent-form {
        .formItem {
          .van-checkbox__label,
          .van-radio__label {
            font-size: 26px;
            color: #475569;
          }
          .van-radio__label {
            line-height: 2rem !important;
          }
          .van-cell__value--alone {
            color: #475569;
          }

          .van-picker {
            .van-hairline--top-bottom {
              height: 3rem;

              > div {
                line-height: 3rem;
                padding: 0 0.625rem;
              }
              .van-picker__cancel,
              .van-picker__confirm {
                font-size: 30px;
              }
            }
            .van-picker__columns {
              .van-picker-column {
                font-size: 1rem;
              }
            }
          }

          .van-search {
            padding: 0;
            .van-search__content {
              padding: 0;
              background-color: #fff;
            }
          }
          .van-cell {
            height: 2.4rem;
            font-size: 0.875rem;
            padding: 0.8rem 0 0 0.625rem;
            .van-field__left-icon {
              .van-icon {
                font-size: 1.2rem;
              }
            }
          }
          .textarea {
            padding: 20px 0px;
            padding-left: 0.625rem;
            min-height: 2.4rem;
            width: 100%;
            font-size: 0.875rem;
            color: #1e293b;
            line-height: 40px;
            border: 1px solid #e2e8f0;
          }
        }
      }
    }
  }
  .submitBtn {
    .van-loading__text {
      font-size: 30px;
      color: #fff;
    }
  }
}
</style>

<style lang="scss" scoped>
.disNone {
  display: none;
}
.ticketType_select {
  border: 2px solid #3b82f6;
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    border-bottom: 30px solid #3b82f6;
    border-left: 30px solid transparent;
    border-top: 30px solid transparent;
  }
}
.nextStep {
  display: flex;
  height: 96px;
  line-height: 108px;
  margin-top: 60px;
  font-size: 28px;

  .nextStep_container {
    border-top: 2px solid #e2e8f0;
    flex: 1;
    padding-left: 4%;
    > span {
      font-size: 32px;
      color: #e6a23c;
    }
  }
  .nextBtn {
    flex: 1;
    height: 96px;
    line-height: 96px;
    text-align: center;
    background: #3b82f6;
    color: #fff;
    letter-spacing: 10px;
    font-size: 30px;
  }
}
// ------------
#addPersonnel {
  width: 100%;
  .registration-container {
    padding-bottom: 80px;
    #num_popup {
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.76);
      z-index: 2;
      .num_popup_container {
        width: 92%;
        position: absolute;
        top: 46%;
        left: 50%;
        transform: translate(-50%, -50%);
        box-shadow: 0 0 4px rgba(0,0,0,0.08);
        border-radius: 12px;
        padding-top: 20px;
        font-size: 28px;
        background: #fff;
        margin: 0 auto;
        .ticketType {
          width: 92%;
          margin: 0 auto;
          margin-bottom: 60px;
          .ticketType_title {
            font-size: 28px;
            height: 80px;
            line-height: 80px;
          }
          .ticketType_item {
            width: 100%;

            font-size: 28px;
            margin-bottom: 20px;

            .ticketType_item_main {
              line-height: 90px;
              box-sizing: border-box;
              padding: 0 3%;
              background: #ffffff;
              box-shadow: 0 2px 12px rgba(0,0,0,0.04);
              border-radius: 12px;
              position: relative;
            }
            .ticketType_item_container {
              height: 90px;
              display: flex;
              justify-content: space-between;
              .price_container {
                font-size: 32px;
                color: #e6a23c;
              }
              .prohibit {
                color: #94a3b8;
              }
            }
            .ticketTypeTips {
              height: 40px;
              line-height: 50px;
              font-size: 26px;
              color: #e6a23c;
            }
          }
        }
        #select_number {
          width: 92%;
          margin: 0 auto;
          .select_number_container {
            .select_number_title {
              font-size: 28px;
              height: 60px;
              line-height: 60px;
            }
            .select_number_content {
              height: 100px;
              line-height: 100px;
              color: #64748b;
              display: flex;
              align-items: center;
              align-content: center;
              .reduce,
              .increase {
                width: 66px;
                height: 60px;
                line-height: 40px;
                background: #f1f5f9;
                font-size: 60px;
                text-align: center;
                position: relative;
                > img {
                  width: 70%;
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                }
              }
              .reduce {
                > img {
                  width: 50%;
                }
              }
              .num {
                height: 56px;
                width: 66px;
                text-align: center;
                line-height: 62px;
                font-size: 28px;
                background: #fff;
                border-radius: 0;
                box-shadow: 0 1px 4px rgba(0,0,0,0.06);
                margin: 0 4px;
                color: #1e293b;
                &::placeholder {
                  font-size: 62px;
                }
              }
              .remainingTickets {
                display: inline-block;
                margin-left: 4%;
              }
            }
          }
        }
      }
    }
    .registration-banner {
      > img {
        width: 100%;
      }
    }
    .registration-content {
      width: 98%;
      margin: 0 auto;
      font-size: 0.875rem;
      font-weight: 300;
      .registrationContent-title {
        text-align: center;
        width: 100%;
        margin: 1rem auto;
        padding-bottom: 16px;
        border-bottom: 1px solid #3b82f6;
        > span {
          font-size: 1.25rem;
          font-weight: 600;
          padding-bottom: 0.375rem;
        }
      }

      .registrationContent-form {
        .formItem {
          padding: 0.625rem;
          margin-bottom: 0.8rem;
          box-shadow: 0 2px 12px rgba(0,0,0,0.04); border: 1px solid #e2e8f0;
          position: relative;
          background-color: #fff;
          .formItem-title {
            margin-bottom: 0.625rem;
            font-size: 28px;
            font-weight: 400;
          }
          > input[type='text'] {
            width: 100%;
            height: 2.4rem;
            font-size: 28px;
            color: #1e293b;
            box-sizing: border-box;
            border: 1px solid #e2e8f0;
            padding: 0 0.625rem;
            box-shadow: none;
            border-radius: 8px;
            &::-webkit-input-placeholder {
              font-size: 26px;
            }
            &:focus {
              border: 1px solid #3b82f6;
            }
          }
          .van-radio,
          .van-checkbox {
            height: 2rem;
            line-height: 2rem !important;
          }

          select {
            height: 2.2rem;
            width: 100%;
            border: 1px solid #e2e8f0;
            -webkit-appearance: none;
            padding-left: 0.625rem;
            font-size: 30px;
            background: url() no-repeat right;
            background-size: 2rem;
            border-radius: 8px;
            color: #475569;
          }
          .van-cell {
            height: 2.2rem;
            font-size: 0.875rem;
            padding: 0.625rem 0.625rem 0 0.625rem;
            border: 1px solid #e2e8f0;
            font-weight: normal;
            line-height: 1rem;
            border-radius: 8px;
          }
          .van-icon {
            font-size: 1.375rem;
          }
          .downIcon {
            position: absolute;
            bottom: 0.98rem;
            right: 1.25rem;
          }
          .searchOption {
            width: 100%;
            border-radius: 8px;
            border: 1px solid #e2e8f0;
            padding: 0.4rem;
            padding-bottom: 0.6rem;
            box-sizing: border-box;
            margin-top: 0.8rem;
            transition: all 2s;
            z-index: 2;
            .searchOption-list {
              .searchOption-item {
                height: 2rem;
                border-bottom: 1px solid #e2e8f0;
                line-height: 2rem;
                font-size: 28px;
              }
            }
          }
          .mustfill {
            color: #f56c6c;
            margin-left: 0.3rem;
          }
        }
        .divider {
          font-size: 24px;
          .dividerLine {
            margin: 20px 0px;
            border-top: 1px solid #e2e8f0;
          }
        }
      }
      .registration-nextStep {
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 1000;
        background: #ffffff;

        .reselect {
          margin-top: 10px;
		  margin-bottom: 20px;
          margin-left: 20px;
          color: #3b82f6;
          font-size: 28px;
          .reselect-content {
            display: flex;
            .van-icon {
              font-size: 36px;
            }
          }
        }
        .nextStep {
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
